// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-header button[data-v-0f5a4c38]{height:34px}.card-body .section-title[data-v-0f5a4c38]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:16px}.card-body .section-title h3[data-v-0f5a4c38]{margin-bottom:0}.card-body .section-title span[data-v-0f5a4c38]{margin:auto auto auto 8px;padding:4px 8px;background-color:#303034;color:#fff;border-radius:4px}", ""]);
// Exports
module.exports = exports;
